export default __webpack_public_path__ + "static/media/icon-loading.9bbdb107.svg";